import { MARQUEE_ITEMS } from "./data";

const Item = ({ item }) => (
  <span className="flex items-center">
    <span className="whitespace-nowrap px-8 font-display text-2xl font-bold uppercase tracking-wide text-white/70">
      {item}
    </span>
    <span className="h-2 w-2 rotate-45 bg-edge" />
  </span>
);

export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-line bg-coal py-5"
      data-testid="marquee-ticker-container"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center">
        {MARQUEE_ITEMS.map((item) => (
          <Item key={`a-${item}`} item={item} />
        ))}
        {MARQUEE_ITEMS.map((item) => (
          <Item key={`b-${item}`} item={item} />
        ))}
      </div>
    </div>
  );
}
